module.exports = __webpack_public_path__ + "img/icon-vc.61d1b450.svg";